import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './utils/AuthContext';
import Landing from './pages/Landing';
import Matches from './pages/consult/Matches';
import ConsultAbout from './pages/consult/ConsultAbout';
import Payment from './pages/consult/Payment';
import Profile from './pages/consult/ProfileCompact';
import Login from './pages/consult/Login';
import Register from './pages/consult/Register';
import Contact from './pages/Contact';
import DecorAbout from './pages/decor/DecorAbout';
import Catalog from './pages/decor/Catalog';
import DecorQuote from './pages/decor/DecorQuote';
import DecorBooking from './pages/decor/DecorBooking';
import CateringAbout from './pages/catering/CateringAbout';
import Team from './pages/catering/Team';
import Menu from './pages/catering/Menu';
import CateringQuote from './pages/catering/CateringQuote';
import CateringBooking from './pages/catering/CateringBooking';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/consultation" element={<Matches />} />
          <Route path="/consultation/about" element={<ConsultAbout />} />
          <Route path="/consultation/payment" element={<Payment />} />
          <Route path="/consultation/profile" element={<Profile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/consultation/login" element={<Login />} />
          <Route path="/consultation/register" element={<Register />} />
          <Route path="/decor" element={<DecorAbout />} />
          <Route path="/decor/catalog" element={<Catalog />} />
          <Route path="/decor/quote" element={<DecorQuote />} />
          <Route path="/decor/booking" element={<DecorBooking />} />
          <Route path="/catering" element={<CateringAbout />} />
          <Route path="/catering/team" element={<Team />} />
          <Route path="/catering/menu" element={<Menu />} />
          <Route path="/catering/quote" element={<CateringQuote />} />
          <Route path="/catering/booking" element={<CateringBooking />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
